// Plan & usage screen (package, limits, features).
export const planEn = {
  'plan.title': 'Plan & Usage',
  'plan.breadcrumbSite': 'Site',
  'plan.subtitle': 'Your package and what it includes. To change it, contact your account manager.',
  'plan.package': 'Package',
  'plan.pkg.starter': 'Starter',
  'plan.pkg.business': 'Business',
  'plan.pkg.advanced': 'Advanced',
  'plan.pkg.store': 'Store',
  'plan.pkgDesc.starter': 'Up to 3 pages and 20 catalogue items, with one CMS account to edit their texts and pictures.',
  'plan.pkgDesc.business': 'A professional site with a CMS, blog and lead capture.',
  'plan.pkgDesc.advanced': 'Up to 25 pages, custom content types, roles and multi-language.',
  'plan.pkgDesc.store': 'Everything in Advanced plus an online store.',
  'plan.hint.pagesFull': 'Page limit reached ({used} of {limit}). Contact your account manager to add more pages.',
  'plan.hint.usersFull': 'All {limit} user seats are in use. Deactivate a user or contact your account manager.',
  'plan.hint.usersNone': 'Your package has no CMS users; your site is managed by our team.',
  'plan.hint.languagesFull': 'Your plan allows {limit} content language(s).',
  'plan.seats': '{used} of {limit} seats used',
  'plan.usage': 'Usage',
  'plan.unlimited': 'Unlimited',
  'plan.limitReached': 'Limit reached',
  'plan.limit.pages': 'Pages',
  'plan.limit.users': 'Active users',
  'plan.limit.languages': 'Content languages',
  'plan.limit.items': 'Catalogue items',
  'plan.limit.articles': 'Articles',
  'plan.limit.storage': 'Media storage (MB)',
  'plan.usageOf': '{used} of {limit}',
  'plan.usedOnly': '{used} in use',
  'plan.features': 'Features',
  'plan.included': 'Included',
  'plan.notIncluded': 'Not included',
  'plan.flag.cms': 'CMS sign-in for your team',
  'plan.flag.blog': 'Blog / news',
  'plan.flag.lead_capture': 'Lead capture and notifications',
  'plan.flag.booking': 'Booking / calendar embed',
  'plan.flag.rename_types': 'Rename catalogue types',
  'plan.flag.custom_types': 'Add and delete catalogue types',
  'plan.flag.rbac': 'Custom roles and permissions',
  'plan.flag.multi_location': 'Multiple locations',
  'plan.flag.custom_domain': 'Your own domain',
  'plan.flag.store': 'Online store',
  'plan.flag.mailbox': 'Inbox for email to your domain',
  'plan.flag.ai_writing': 'AI writing assistant',
  'plan.flag.seo': 'SEO fields and settings',
  'plan.flag.tracking': 'Tracking (Google Analytics, Meta Pixel, TikTok)',
  'plan.notInPackage': 'Not in your package',
  'plan.locked.seo': 'Page titles and descriptions come from your content automatically.',
  'plan.locked.tracking': 'No tracking scripts are added to your site.',
  'plan.scope.content': 'Your package covers the texts and pictures of your pages and catalogue. Site settings, menus, users, articles and quote requests are not in your package.',
} as const

export const planId: Record<keyof typeof planEn, string> = {
  'plan.title': 'Paket & Penggunaan',
  'plan.breadcrumbSite': 'Situs',
  'plan.subtitle': 'Paket Anda dan apa saja yang termasuk. Untuk mengubahnya, hubungi account manager Anda.',
  'plan.package': 'Paket',
  'plan.pkg.starter': 'Starter',
  'plan.pkg.business': 'Business',
  'plan.pkg.advanced': 'Advanced',
  'plan.pkg.store': 'Store',
  'plan.pkgDesc.starter': 'Hingga 3 halaman dan 20 item katalog, dengan satu akun CMS untuk mengubah teks dan gambarnya.',
  'plan.pkgDesc.business': 'Situs profesional dengan CMS, blog, dan penangkapan prospek.',
  'plan.pkgDesc.advanced': 'Hingga 25 halaman, tipe konten kustom, peran, dan multibahasa.',
  'plan.pkgDesc.store': 'Semua fitur Advanced ditambah toko online.',
  'plan.hint.pagesFull': 'Batas halaman tercapai ({used} dari {limit}). Hubungi account manager Anda untuk menambah halaman.',
  'plan.hint.usersFull': 'Seluruh {limit} kursi pengguna terpakai. Nonaktifkan pengguna atau hubungi account manager Anda.',
  'plan.hint.usersNone': 'Paket Anda tidak memiliki pengguna CMS; situs Anda dikelola oleh tim kami.',
  'plan.hint.languagesFull': 'Paket Anda mengizinkan {limit} bahasa konten.',
  'plan.seats': '{used} dari {limit} kursi terpakai',
  'plan.usage': 'Penggunaan',
  'plan.unlimited': 'Tanpa batas',
  'plan.limitReached': 'Batas tercapai',
  'plan.limit.pages': 'Halaman',
  'plan.limit.users': 'Pengguna aktif',
  'plan.limit.languages': 'Bahasa konten',
  'plan.limit.items': 'Item katalog',
  'plan.limit.articles': 'Artikel',
  'plan.limit.storage': 'Penyimpanan media (MB)',
  'plan.usageOf': '{used} dari {limit}',
  'plan.usedOnly': '{used} digunakan',
  'plan.features': 'Fitur',
  'plan.included': 'Termasuk',
  'plan.notIncluded': 'Tidak termasuk',
  'plan.flag.cms': 'Akses CMS untuk tim Anda',
  'plan.flag.blog': 'Blog / berita',
  'plan.flag.lead_capture': 'Penangkapan prospek dan notifikasi',
  'plan.flag.booking': 'Sematan booking / kalender',
  'plan.flag.rename_types': 'Ubah nama tipe katalog',
  'plan.flag.custom_types': 'Tambah dan hapus tipe katalog',
  'plan.flag.rbac': 'Peran dan izin kustom',
  'plan.flag.multi_location': 'Beberapa lokasi',
  'plan.flag.custom_domain': 'Domain milik Anda sendiri',
  'plan.flag.store': 'Toko online',
  'plan.flag.mailbox': 'Kotak masuk untuk email ke domain Anda',
  'plan.flag.ai_writing': 'Asisten penulisan AI',
  'plan.flag.seo': 'Kolom dan pengaturan SEO',
  'plan.flag.tracking': 'Pelacakan (Google Analytics, Meta Pixel, TikTok)',
  'plan.notInPackage': 'Tidak termasuk paket Anda',
  'plan.locked.seo': 'Judul dan deskripsi halaman otomatis diambil dari isi konten Anda.',
  'plan.locked.tracking': 'Situs Anda tidak memasang skrip pelacakan.',
  'plan.scope.content': 'Paket Anda mencakup teks dan gambar di halaman dan katalog. Pengaturan situs, menu, pengguna, artikel, dan penawaran masuk tidak termasuk paket Anda.',
}
